import { CIMSPage } from '@cims-online/shared'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { HelpMessage } from 'utils/constants'
import { DSAction } from '../../../ActionsTableContext'

export function useExpand(): ExpandOptions<DSAction> {
  return {
    expandable: ({ submittals }) => !!submittals.length,
    render: ({ id, submittals }) => {
      return {
        additionalInfo: [
          {
            label: 'Associated Submittals',
            help: HelpMessage.DesignSubmittals.Actions.AssociatedSubmittals,
            type: 'deepLinks',
            showMore: { key: id },
            links: submittals.map(
              ({ packageName, deleted, id, packageNumber }) => ({
                label: packageNumber,
                tooltip: packageName,
                page: CIMSPage.DSLog,
                deep: {
                  recordId: id,
                  deleted,
                },
              })
            ),
          },
        ],
      }
    },
  }
}
